export enum ETraitement {
    LDE = 1,
    Manuel = 2,
    ProcédureClient = 3,
    NonTransmis = 4,
}